const ROUTE_LOAD_RECOVERY_KEY = 'cms.route-load-recovery'

/** 可选的路由恢复行为；测试可注入刷新动作，生产环境使用浏览器刷新。 */
export interface RouteLoadOptions {
  reload?: () => void
}

/**
 * 统一加载路由组件，并在开发服务模块图/缓存失配时给页面一次重建机会。
 * 成功加载后清除标记，第二次失败由 Router 的全局错误处理接管。
 */
export async function loadRoute<T>(loader: () => Promise<T>, options?: RouteLoadOptions): Promise<T> {
  try {
    const component = await loader()
    clearRecoveryAttempt()
    return component
  } catch (error) {
    if (markRecoveryAttempt()) {
      if (options?.reload) options.reload()
      else window.location.reload()
    }
    throw error
  }
}

function markRecoveryAttempt(): boolean {
  try {
    if (sessionStorage.getItem(ROUTE_LOAD_RECOVERY_KEY) === '1') return false
    sessionStorage.setItem(ROUTE_LOAD_RECOVERY_KEY, '1')
    return true
  } catch {
    // 存储不可用时不刷新，交给可见错误页，避免无法终止的刷新循环。
    return false
  }
}

function clearRecoveryAttempt(): void {
  try {
    sessionStorage.removeItem(ROUTE_LOAD_RECOVERY_KEY)
  } catch {
    // 隐私模式下 storage 可能不可用，不影响正常路由加载。
  }
}

export { ROUTE_LOAD_RECOVERY_KEY }
